import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import LatestRoles from './components/LatestRoles';
import LatestJobs from './components/LatestJobs';
import Credentials from './components/Credentials';
import HowItWorks from './components/HowItWorks';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import JobsPage from './components/JobsPage';
import AboutPage from './components/AboutPage';
import CVForm from './components/CVForm';
import JobDetailPage from './components/JobDetailPage';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import ProtectedRoute from './components/admin/ProtectedRoute';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiePolicy from './components/CookiePolicy';
import CookieBanner from './components/CookieBanner';

function HomePage() {
  return (
    <>
      <Hero />
      <LatestRoles />
      <Credentials />
      <LatestJobs />
      <HowItWorks />
      <FAQ />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Admin routes (without Navbar/Footer) */}
              <Route path="/admin" element={<AdminLogin />} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              
              {/* Public routes (with Navbar/Footer) */}
              <Route
                path="/*"
                element={
                  <>
                    <Navbar />
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/jobs" element={<JobsPage />} />
                      <Route path="/jobs/:id" element={<JobDetailPage />} />
                      <Route path="/about" element={<AboutPage />} />
                      <Route path="/cv" element={<CVForm />} />
                      <Route path="/privacy" element={<PrivacyPolicy />} />
                      <Route path="/cookies" element={<CookiePolicy />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Footer />
                    <CookieBanner />
                  </>
                }
              />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
      <Analytics />
      <SpeedInsights />
    </LanguageProvider>
  );
}

export default App;
